"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = void 0;
;
exports.actions = {
  actors: {
    read: "actors.read",
    write: "actors.write"
  },
  catalog: {
    read: "catalog.read",
    write: "catalog.write",
    products: {
      read: "catalog.products.read",
      write: "catalog.products.write"
    },
    components: {
      read: "catalog.components.read",
      write: "catalog.components.write"
    }
  },
  concepts: {
    read: "concepts.read",
    write: "concepts.write"
  },
  employees: {
    read: "employees.read",
    write: "employees.write"
  },
  inventory: {
    counts: {
      read: "inventory.counts.read",
      write: "inventory.counts.write"
    },
    items: {
      read: "inventory.items.read"
    },
    locations: {
      read: "inventory.locations.read",
      write: "inventory.locations.write"
    }
  },
  menu: {
    items: {
      read: "menu.items.read"
    }
  },
  organizations: {
    read: "organizations.read",
    write: "organizations.write",
    manage_concepts: "organizations.manage_concepts"
  },
  reports: {
    create: "reports.create",
    read: "reports.read",
    share: "reports.share",
    manage: "reports.manage"
  },
  sales: {
    read: "sales.read",
    confirm_receipt: "sales.confirm_receipt",
    validate: "sales.validate",
    write: "sales.write"
  },
  units: {
    read: "units.read",
    write: "units.write",
    create: "units.create",
    transfer_ownership: "units.transfer_ownership",
    system_management: "units.system_management"
  },
  structure: {
    read: "structure.read",
    write: "structure.write"
  },
  config: {
    read: "config.read",
    manage: "config.manage"
  }
};